import React from 'react';
import {IClassNameProps} from "@bem-react/core";
import {cnWizardSpec} from '../WizardSpec';
import {WizardSpecImage} from '../Image/WizardSpec-Image';
import {Button} from '../../../components/Button';
import {useTranslation} from 'react-i18next';
import {TImageScreenSettings} from "../../../../../common-code/types/project/TImageScreenSettings";
import {useDispatch} from "react-redux";
import {KitchenService} from "../../../../3d/services/KitchenService/KitchenService";
import {TChangeAspectData} from "../../../../../common-code/types/project/TChangeAspectData";
import {PROCESS_CHANGE_ASPECT} from "../../../../constants";
import {TKitchenImageSet} from "../../../../../common-code/types/project/TKitchenImageSet";

export interface IWizardSpecSnapshotProps extends IClassNameProps {
    service: KitchenService;
    imagesSet: TKitchenImageSet;
    index: number;
    screenSettings?: TImageScreenSettings;
}

export const WizardSpecSnapshot: React.FC<IWizardSpecSnapshotProps> =
    ({
         imagesSet,
         screenSettings,
         service,
         index
     }) => {
        const {t} = useTranslation();
        const dispatch = useDispatch();

        const showProcessChangeAspect = (changeData: TChangeAspectData) => {
            if (changeData.target && changeData.camera) {
                service.setTarget(changeData.target);
                service.setCameraPosition(changeData.camera);
            } else {
                service.showAll();
            }
            dispatch({
                type: PROCESS_CHANGE_ASPECT,
                payload: changeData,
            });
        }

        const deleteChangeAspect = (index: number) => {
            service.deleteScreenSettings(index);
        }

        return (
            <div className={cnWizardSpec('Snapshot')}>
                <WizardSpecImage image={imagesSet.visual} type={'visual'}
                                 className={cnWizardSpec('SnapshotImage', {type: 'visual'})}/>
                <WizardSpecImage image={imagesSet.sketch} type={'sketch'}
                                 className={cnWizardSpec('SnapshotImage', {type: 'sketch'})}/>
                <div className={cnWizardSpec('Buttons')}>
                    {index === -1 || <div className={cnWizardSpec('DeleteAspect')}>
                        <Button
                            className={cnWizardSpec('Button')}
                            leftIcon={{path: 'delete', width: 20, height: 20, marginRight: 8}}
                            text={''}
                            callBack={() => {
                                deleteChangeAspect(index)
                            }}
                            mods={{
                                mods: {
                                    color: 'black',
                                    bkg: 'white',
                                    border: 'gray',
                                    fill: 'lightBlack'
                                },
                            }}
                            type={'button'}
                        />
                    </div>}
                    <div className={cnWizardSpec('ShowAspect')}>
                        <Button
                            className={cnWizardSpec('Button')}
                            leftIcon={{path: 'rotate', width: 20, height: 20, marginRight: 8}}
                            text={t('Сменить ракурс') || undefined}
                            callBack={() => {
                                showProcessChangeAspect({
                                    index: index,
                                    target: screenSettings?.target,
                                    camera: screenSettings?.camera
                                } as TChangeAspectData)
                            }}
                            mods={{
                                mods: {
                                    color: 'black',
                                    bkg: 'white',
                                    border: 'gray',
                                    fill: 'lightBlack'
                                },
                            }}
                            type={'button'}
                        />
                    </div>
                </div>
            </div>
        );
    };